import React, { useState } from "react";
// LA VESTE (cantiere «grafica enrollment», passo 1). `Login.css` e
// `Register.css` sono stati ritirati: la pagina prende ora le classi del tema.
//   HomeShell.css  — il guscio (`.qpsc-page`, `.qpsc-column`) e il titolo
//                    (`.qpsc-page-title`). Si importa il FOGLIO, non il
//                    componente `HomeShell`: questa è una pagina PUBBLICA e
//                    non porta né barra utente né banda di navigazione
//                    (doc 07 §7.1/§7.2), che presuppongono un utente collegato.
//   AdminTools.css — pulsanti (§5.1, §5.3) e campi (§8), condivisi con tutta
//                    l'app: qui non se ne ridichiara nemmeno uno.
//   Enrolment.css  — il poco che è proprio di queste cinque pagine.
import "../components/HomeShell.css";
import "../components/AdminTools.css";
import "./Enrolment.css";
// LE LINGUE D'AIUTO (cantiere «enrollment» 2). Le parole della pagina vengono
// ora dal dizionario unico — sono le stesse, alla lettera — e sotto ciascuna
// può comparire una riga d'aiuto in arabo, cinese o hindi. Chi non tocca
// l'interruttore vede la pagina di prima, e non scarica un byte in più.
import { testo as t } from "./enrolLingue";
import { Aiuto, BarraLingue, ProvvistaLingua } from "./enrolAiuto";
import { api } from "../api/api";
import { useAuth } from "../context/AuthContext";

// ⚠️ RL-8b — L'ACCESSO È UN LINK VIA EMAIL, E NIENT'ALTRO.
//
// Da questa pagina sono spariti, per decisione del cantiere:
//   - email + password (`signInWithEmailAndPassword`) e il campo password;
//   - telefono/SMS/reCAPTCHA (`signInWithPhoneNumber`, `RecaptchaVerifier`,
//     `setupRecaptcha`, `toE164AU`, `normalizePhone` — già morta —, il
//     <div id="recaptcha-container"> e le linguette Email/Phone);
//   - Google (`signInWithPopup`);
//   - il recupero password (`sendPasswordResetEmail`): senza password non
//     c'è nulla da recuperare, il link di accesso È il recupero;
//   - il segnaposto biometrico;
//   - la stampa in console del profilo dell'utente.
//
// ⚠️ E con i gestori sono sparite le chiamate a `GET /users?uid=` che ognuno
// di essi faceva. D-03 (1/10/2026): la pagina fa ora UNA sola chiamata al
// backend, `POST /auth/send-signin-link`, che compone e spedisce il link con
// l'email del club — e non dice nulla di chi sia la persona: risponde uguale
// per socio e non socio. Chi è questa persona, se ha una scheda e dove va a
// finire lo decide l'osservatore di AuthContext dopo l'autenticazione, e poi
// il cancello (RequireRole): qui non se ne sa e non se ne deve sapere nulla.
//
// ⚠️ NESSUN ORACOLO. Il messaggio dopo l'invio è lo stesso identico sia che
// l'indirizzo digitato sia iscritto sia che non lo sia: la rotta del club
// risponde allo stesso modo in entrambi i casi (solo un guasto tecnico dà
// errore, e il messaggio d'errore è generico), e questa pagina non ha
// modo — né titolo — di dire a un estraneo se una certa email appartenga a
// un socio del club. Il controllo vero avviene DOPO il clic, lato backend (RL-8a) e nell'osservatore.
//
// ⚠️ RL-6 — QUI VIVEVA `ROLE_HOME_MAP` (coda 10), ed è stata TOLTA.
// La mappa ruolo→rotta dell'app è UNA sola, `ROLE_ROUTES` in
// src/auth/access.js, e la legge l'instradatore (/home). Il login non decide
// dove mandare nessuno. Non se ne rimettano di nuove.

/**
 * Chiave di `window.localStorage` in cui si parcheggia l'indirizzo a cui si è
 * chiesto il link, per poterlo riusare al ritorno senza chiederlo di nuovo.
 *
 * Vive QUI ed è importata da FinishLogin.jsx: una sola sede, perché le due
 * pagine devono scrivere e leggere la stessa identica chiave — se divergesse,
 * il ritorno chiederebbe sempre l'email a mano e nessun errore lo direbbe.
 */
export const CHIAVE_EMAIL_ACCESSO = "emailForSignIn";

/**
 * LE FRASI DEGLI INGRESSI NON RIUSCITI (RL-8c).
 *
 * L'osservatore di AuthContext dice PERCHÉ (un codice: "not-enrolled",
 * "email-ambiguous", "profile-error"); le parole stanno nel dizionario unico
 * (enrolLingue.js), e questa tabella dice quale frase risponde a quale codice.
 *
 * ⚠️ CANTIERE 2 — QUI STAVANO LE PAROLE, ORA CI STANNO LE CHIAVI. Le frasi non
 * sono cambiate di una lettera: si sono spostate nel dizionario, perché sotto
 * ciascuna deve poter comparire la riga d'aiuto tradotta, e una traduzione si
 * trova per chiave e non per frase.
 *
 * ⚠️ NESSUN ORACOLO, ed è un caso diverso da quello del messaggio neutro
 * (`login.sent`): questi messaggi si vedono solo DOPO che qualcuno ha aperto
 * il link ricevuto a quell'indirizzo, cioè ha già dimostrato di leggerne la
 * posta. Dirgli «questo indirizzo non è iscritto» non svela niente a un
 * estraneo. Su «email-ambiguous» la frase resta comunque generica: che di
 * schede ce ne siano due è un fatto dell'anagrafica del club, non suo.
 */
const CHIAVI_ESITO = {
  "not-enrolled": "login.err.notEnrolled",
  "email-ambiguous": "login.err.ambiguous",
  "profile-error": "login.err.profile"
};

// Il contenitore di stato della lingua d'aiuto avvolge la PAGINA: così
// l'interruttore in cima e ogni riga d'aiuto più sotto guardano la stessa
// scelta. Non aggiunge markup e non tocca niente della pagina.
export default function Login() {
  return (
    <ProvvistaLingua>
      <PaginaLogin />
    </ProvvistaLingua>
  );
}

function PaginaLogin() {
  // Perché l'ultimo ingresso non è riuscito, e come cancellarlo. Nient'altro
  // di questo contesto serve qui: chi è la persona lo decidono l'osservatore e
  // il cancello, non la pagina di accesso.
  const { authReason, clearAuthReason } = useAuth();
  const [email, setEmail] = useState("");
  const [inviato, setInviato] = useState(false);
  // ⚠️ Cantiere 2: `errore` non tiene più la frase, tiene la sua CHIAVE nel
  // dizionario. La frase è la stessa; l'identità del messaggio non è più il
  // suo testo.
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendLink = async (e) => {
    e.preventDefault();
    // Normalizzazione banale, la stessa che si userà al ritorno: gli spazi
    // incollati per sbaglio e il maiuscolo non devono cambiare l'indirizzo.
    const indirizzo = email.trim().toLowerCase();
    if (!indirizzo) return;

    setLoading(true);
    setErrore("");
    // La persona sta agendo adesso: il messaggio del tentativo precedente non
    // deve restarle davanti mentre chiede un link nuovo.
    clearAuthReason();

    try {
      // D-03: il link lo compone e lo spedisce il backend (indirizzo di
      // ritorno `${APP_URL}/finish-login`), con l'email del club. La risposta
      // è neutra; un errore (502 o rete) finisce nel catch qui sotto.
      await api.post("/auth/send-signin-link", { email: indirizzo });

      // Serve solo a completare l'accesso al ritorno: se il browser lo vieta
      // (navigazione privata) non è un guaio, FinishLogin.jsx chiederà
      // l'indirizzo a mano.
      try {
        window.localStorage.setItem(CHIAVE_EMAIL_ACCESSO, indirizzo);
      } catch (_) {
        /* localStorage non disponibile: si prosegue lo stesso. */
      }

      setInviato(true);
    } catch (err) {
      // Messaggio generico: un errore non deve diventare la spia del fatto
      // che quell'indirizzo esista o non esista.
      setErrore("login.err.send");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="qpsc-page">
      <main className="qpsc-column">
        {/* L'INTERRUTTORE DI LINGUA, in testa al guscio (mockup approvato):
            è la prima cosa che serve a chi non legge l'inglese, quindi sta
            prima di tutto il resto. L'avviso («si legge nella propria
            lingua, si scrive in inglese») è una delle DUE sole schermate
            che lo mostrano (l'altra è la scelta del percorso di /enrol):
            qui si arriva da fuori. Dopo l'invio sparisce — non c'è più
            niente da scrivere. */}
        <BarraLingue avviso={!inviato} />

        {/* LA TESTA È UNA COLONNA: logo nel cerchio d'oro e titolo centrato
            sotto (doc 07 §3.1). Il riquadro che galleggiava — bordo rosso,
            ombra, fondo proprio — non c'è più: la pagina È la superficie. */}
        <header className="qpsc-en-head">
          <img src="/images/logo.png" alt="QPSC Logo" className="qpsc-en-logo" />
          <h2 className="qpsc-page-title">
            {t("login.title")}
            <Aiuto k="login.title" colore="titolo" />
          </h2>
        </header>

        {/* ESITO DELL'ULTIMO INGRESSO, in cima e prima del modulo: è la prima
            cosa da leggere per chi è appena stato rimandato qui, e spiega
            perché ci si ritrova. Nessun colore scritto a mano: il rosso è il
            rosso LEGGIBILE del §1.3, che è la regola per i testi.

            Su "not-enrolled" non serve aggiungere nessun collegamento: la porta
            d'iscrizione (/enrol) sta in fondo alla pagina e ci sta sempre.

            Su "profile-error" la sessione Firebase è ancora viva — quel ramo
            dell'osservatore non fa `signOut` di proposito — quindi ricaricare
            basta: l'osservatore riparte su quella sessione e ritenta la lettura,
            senza chiedere un altro link. */}
        {CHIAVI_ESITO[authReason] && (
          <>
            <p className="qpsc-en-msg qpsc-en-msg--error">
              {t(CHIAVI_ESITO[authReason])}
              <Aiuto k={CHIAVI_ESITO[authReason]} colore="errore" />
            </p>
            {authReason === "profile-error" && (
              <>
                <button
                  className="qpsc-ghost-btn qpsc-en-ghost"
                  type="button"
                  onClick={() => window.location.reload()}
                >
                  {t("login.retry")}
                </button>
                <Aiuto k="login.retry" colore="oro" />
              </>
            )}
          </>
        )}

        {inviato ? (
          <p className="qpsc-en-msg qpsc-en-msg--ok">
            {t("login.sent")}
            <Aiuto k="login.sent" colore="ok" />
          </p>
        ) : (
          <form className="qpsc-en-form" onSubmit={handleSendLink}>
            {/* §8: l'etichetta sta SOPRA il campo. Prima c'era il solo
                segnaposto, che sparisce appena si scrive: chi torna sul modulo
                a metà compilazione non aveva più modo di sapere che cosa
                stesse scrivendo. Il segnaposto resta dov'era — è testo della
                pagina e questo cantiere non tocca i testi. */}
            <label className="qpsc-field">
              <span className="qpsc-field__label">{t("field.emailLogin")}</span>
              {/* ⚠️ IL SEGNAPOSTO RESTA IN INGLESE, e non è una dimenticanza:
                  l'indirizzo si scrive in inglese, e il segnaposto è un
                  esempio di ciò che si digita, non una parola da leggere. */}
              <Aiuto k="field.emailLogin" />
              <input
                type="email"
                className="qpsc-input"
                placeholder="Email"
                value={email}
                autoComplete="username"
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                required
              />
            </label>
            <button
              className="qpsc-tool-btn qpsc-tool-btn--wide"
              type="submit"
              disabled={loading}
            >
              {loading ? t("login.submit.sending") : t("login.submit")}
            </button>
            {/* L'aiuto del pulsante sta FUORI dal pulsante, come nel mockup:
                il premibile resta il rettangolo oro, non una riga di testo. */}
            <Aiuto
              k={loading ? "login.submit.sending" : "login.submit"}
              colore="corpo"
              centrato
            />
          </form>
        )}

        {errore && (
          <p className="qpsc-en-msg qpsc-en-msg--error">
            {t(errore)}
            <Aiuto k={errore} colore="errore" />
          </p>
        )}

        {inviato && (
          <>
            <button
              className="qpsc-ghost-btn qpsc-en-ghost"
              type="button"
              onClick={() => {
                setInviato(false);
                setErrore("");
              }}
            >
              {t("login.useOtherEmail")}
            </button>
            <Aiuto k="login.useOtherEmail" colore="oro" />
          </>
        )}

        <div className="qpsc-en-links">
          {/* RL-5b: la porta d'iscrizione è una sola, /enrol. Resta un <a> con
              ricaricamento di pagina, com'era: cambiarlo in <Link> è materia
              d'altro cantiere. Sta SEMPRE in vista, anche dopo l'invio del
              link: chi non è iscritto non riceverà nulla di utile via email e
              deve poter trovare la porta giusta senza tornare indietro. */}
          <a href="/enrol" className="qpsc-en-link">
            {t("login.enrolLink")}
            <Aiuto k="login.enrolLink" colore="oro" />
          </a>
        </div>
        {/* P2 (24/9/2026): chi si è iscritto a una CLINIC dal link pubblico
            non è socio, e «ENROL NOW» — l'iscrizione al CLUB — non fa per
            lui. Questa riga gli dice che il suo modulo è quello qui sopra.
            È una nota (§3.1 S, `.qpsc-note`), centrata come il link che la
            precede; testo scritto qui e non nel dizionario delle lingue
            (enrolLingue.js, generato da un riferimento congelato): niente
            riga d'aiuto, per ora. */}
        <div className="qpsc-en-links">
          <p className="qpsc-note">
            Enrolled in a clinic? Sign in with the email address you used to enrol.
          </p>
        </div>
      </main>
    </div>
  );
}
